module.exports = __webpack_public_path__ + "img/project-8.2367b056.jpg";